import { chakra, Image } from '@chakra-ui/react';
import React from 'react';

import type { NavItem, NavGroupItem } from 'types/client/navigation';

import IconSvg from 'ui/shared/IconSvg';

interface Props {
  className?: string;
  item: NavItem | NavGroupItem;
  size?: number;
}

const NavLinkIcon = ({ item, className, size = 16 }: Props) => {
  const figmaIconMap: Record<string, string> = {
    'nav-index': '/static/navigation/nav-index.svg',
    'nav-block': '/static/navigation/nav-blockchain.svg',
    'nav-tokens': '/static/navigation/nav-tokens.svg',
    'nav-charts': '/static/navigation/nav-charts.svg',
    'nav-others': '/static/navigation/nav-other.svg',
  };

  if ('icon' in item && item.icon) {
    const iconSrc = figmaIconMap[item.icon];

    if (iconSrc) {
      return <Image className={ className } src={ iconSrc } alt="" boxSize={ `${ size }px` } flexShrink={ 0 }/>;
    }

    return <IconSvg className={ className } name={ item.icon } boxSize="16px" flexShrink={ 0 }/>;
  }
  if ('iconComponent' in item && item.iconComponent) {
    const IconComponent = item.iconComponent;
    return <IconComponent className={ className } size={ size }/>;
  }

  return null;
};

export default chakra(NavLinkIcon);
